import React, {Component} from 'react'
// import {Form, Button, Card} from 'react-bootstrap'
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  Image,
  VStack,
} from '@chakra-ui/react'
import colors from '../../theme/colors'

class SignInBoxNew extends Component {
  render() {
    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={colors.background.main}
        position="relative"
        >
        <Box bg={colors.primary.main} h="160px" w="100%" position="absolute" top="0">
          <VStack justify="center" h="100%" spacing={4}>
            <Image src="/volt_logo.png" boxSize="80px" alt="Demos Platform Logo" />
          </VStack>
        </Box>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6} position="relative" zIndex="1" mt="120px">
          <VStack spacing={4} align={'center'}>
            {/* <Image src="/logo.png" boxSize="80px" alt="Demos Platform Logo" /> */}
            <Heading fontSize={'4xl'}>
              <Text as="span" color={colors.text.primary}>Welkom bij </Text>
              <Text as="span" color={colors.primary.main}>Demos</Text>
              <Text as="span" color={colors.text.primary}>.</Text>
            </Heading>
            <Text fontSize={'lg'} color={colors.text.secondary}>Log in bij je account</Text>
          </VStack>
          <Box
            bg={colors.background.white}
            rounded={'lg'}
            boxShadow={'md'}
            p={{ base: 4, md: 6 }}
            mx={{ base: 2, md: 0 }}
            textAlign="center"
          >
            <Text fontSize={{ base: 'sm', md: 'md' }} color={colors.text.secondary}>
              Op dit platform kun je suggesties voor Utrecht indienen. Hiervoor moet je <Text as="span" fontWeight="bold">Inloggen</Text>. Als je geen account hebt kun je <Text as="span" fontWeight="bold">Naar Registreren</Text> om een account te maken. Als je een suggestie wilt indienen zonder account te maken, druk op <Text as="span" fontWeight="bold">Inloggen zonder Account</Text>.
            </Text>
          </Box>
          <Box
            rounded={'lg'}
            bg={colors.background.white}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="name">
                <FormLabel>Gebruikersnaam</FormLabel>
                <Input type="name"
                bg={colors.form.inputBg}
                onChange = {(event) => {this.props.onNameChange(event.target.value)}}/>
              </FormControl>
              <FormControl id="password">
                <FormLabel>Wachtwoord</FormLabel>
                <Input type="password"
                bg={colors.form.inputBg}
                onChange = {(event) => {this.props.onPasswordChange(event.target.value)}}/>
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}>
                  <Link
                    color={colors.text.link}
                    fontSize={'sm'}
                    fontWeight="600"
                    textDecoration="underline"
                    onClick={() => this.props.onRouteChange('passwordResetRequest')}
                    cursor="pointer"
                    _hover={{ color: colors.text.linkHover }}
                  >
                    Wachtwoord vergeten?
                  </Link>
                </Stack>
                <Button
                  bg={colors.button.primary}
                  color={colors.text.white}
                  _hover={{
                    bg: colors.button.primaryHover,
                  }}
                  _active={{
                    bg: colors.button.primaryActive,
                  }}
                  onClick = {this.props.checkSignIn}
                  isLoading={this.props.state?.isLoggingIn}
                  loadingText="Inloggen...">
                  Inloggen
                </Button>
                <Button
                  bg={colors.button.secondary}
                  color={colors.text.white}
                  _hover={{
                    bg: colors.button.secondaryHover,
                  }}
                  _active={{
                    bg: colors.button.secondaryActive,
                  }}
                  onClick = {() => {this.props.onRouteChange('register')}}>
                  Naar Registreren
                </Button>
                <Button
                  variant="outline"
                  borderColor={colors.primary.main}
                  color={colors.primary.main}
                  _hover={{
                    bg: colors.primary.pale,
                  }}
                  onClick = {this.props.onGuestLogin}>
                  Inloggen zonder Account
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    );
  }
}

class RegisterBoxNew extends Component {
  render() {
    return (
      <Flex
        minH={'100vh'}
        align={'center'}
        justify={'center'}
        bg={colors.background.main}
        position="relative"
        >
        <Box bg={colors.primary.main} h="160px" w="100%" position="absolute" top="0">
          <VStack justify="center" h="100%" spacing={4}>
            <Image src="/volt_logo.png" boxSize="80px" alt="Demos Platform Logo" />
          </VStack>
        </Box>
        <Stack spacing={8} mx={'auto'} maxW={'lg'} py={12} px={6} position="relative" zIndex="1" mt="120px">
          <VStack spacing={4} align={'center'}>
            {/* <Image src="/logo.png" boxSize="80px" alt="Demos Platform Logo" /> */}
            <Heading fontSize={'4xl'}>
              <Text as="span" color={colors.text.primary}>Welkom bij </Text>
              <Text as="span" color={colors.primary.main}>Demos</Text>
              <Text as="span" color={colors.text.primary}>.</Text>
            </Heading>
            <Text fontSize={'lg'} color={colors.text.secondary}>Creeer je account</Text>
          </VStack>
          <Box
            rounded={'lg'}
            bg={colors.background.white}
            boxShadow={'lg'}
            p={8}>
            <Stack spacing={4}>
              <FormControl id="name">
                <FormLabel>Gebruikersnaam</FormLabel>
                <Input type="name"
                bg={colors.form.inputBg}
                onChange = {(event) => {this.props.onNameChange(event.target.value)}}/>
              </FormControl>
              <FormControl id="email">
                <FormLabel>Email</FormLabel>
                <Input type="email"
                bg={colors.form.inputBg}
                onChange = {(event) => {this.props.onEmailChange(event.target.value)}}/>
              </FormControl>
              <FormControl id="password">
                <FormLabel>Wachtwoord</FormLabel>
                <Input type="password"
                bg={colors.form.inputBg}
                onChange = {(event) => {this.props.onPasswordChange(event.target.value)}}/>
              </FormControl>
              <Stack spacing={10}>
                <Stack
                  direction={{ base: 'column', sm: 'row' }}
                  align={'start'}
                  justify={'space-between'}>
                </Stack>

                {/* Age Verification */}
                <FormControl isRequired>
                  <Checkbox
                    isChecked={this.props.state?.ageVerified || false}
                    onChange={(e) => this.props.onAgeVerifiedChange(e.target.checked)}
                    sx={{
                      '.chakra-checkbox__control': {
                        borderColor: colors.form.inputBorder,
                        _checked: {
                          bg: colors.primary.main,
                          borderColor: colors.primary.main,
                          _hover: {
                            bg: colors.primary.dark,
                            borderColor: colors.primary.dark,
                          }
                        }
                      }
                    }}
                  >
                    <Text fontSize="sm" color={colors.text.primary}>
                      Ik ben 16 jaar of ouder
                    </Text>
                  </Checkbox>
                </FormControl>

                {/* Terms and Privacy Acceptance */}
                <FormControl isRequired>
                  <Checkbox
                    isChecked={this.props.state?.agreedToTerms || false}
                    onChange={(e) => this.props.onTermsChange(e.target.checked)}
                    sx={{
                      '.chakra-checkbox__control': {
                        borderColor: colors.form.inputBorder,
                        _checked: {
                          bg: colors.primary.main,
                          borderColor: colors.primary.main,
                          _hover: {
                            bg: colors.primary.dark,
                            borderColor: colors.primary.dark,
                          }
                        }
                      }
                    }}
                  >
                    <Text fontSize="sm" color={colors.text.primary}>
                      Ik ga akkoord met de{' '}
                      <Link
                        color={colors.text.link}
                        fontWeight="600"
                        textDecoration="underline"
                        onClick={() => this.props.onRouteChange('termsOfService')}
                        cursor="pointer"
                        _hover={{ color: colors.text.linkHover }}
                      >
                        Algemene Voorwaarden
                      </Link>
                      {' '}en het{' '}
                      <Link
                        color={colors.text.link}
                        fontWeight="600"
                        textDecoration="underline"
                        onClick={() => this.props.onRouteChange('privacyPolicy')}
                        cursor="pointer"
                        _hover={{ color: colors.text.linkHover }}
                      >
                        Privacybeleid
                      </Link>
                    </Text>
                  </Checkbox>
                </FormControl>


                <Button
                  bg={colors.button.primary}
                  color={colors.text.white}
                  _hover={{
                    bg: colors.button.primaryHover,
                  }}
                  _active={{
                    bg: colors.button.primaryActive,
                  }}
                  onClick = {this.props.onRegister}
                  isLoading={this.props.state?.isRegistering}
                  loadingText="Registreren...">
                  Account Aanmaken
                </Button>
                <Button
                  bg={colors.button.secondary}
                  color={colors.text.white}
                  _hover={{
                    bg: colors.button.secondaryHover,
                  }}
                  _active={{
                    bg: colors.button.secondaryActive,
                  }}
                  onClick = {() => {this.props.onRouteChange('login')}}>
                  Naar Inloggen
                </Button>
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </Flex>
    );
  }
}

// class SignIn extends Component {
//     render () {
//       return (
//         <Card 
//         class = "login"
//         bg = "light"
//         border = "secondary"
//         style={{ width: '36rem' }}>
//         {this.props.state.route === 'login'
//         ?
//           <Card.Body>
//             <SignInBox
//             onNameChange = {this.props.onNameChange}
//             onPasswordChange = {this.props.onPasswordChange}/>
//               <Form.Group>
//                 <Button 
//                 onClick = {() => {this.props.onRouteChange('register')}}
//                 variant = "secondary" 
//                 >Sign Up
//                 </Button>
//                 <Button 
//                 variant = "secondary" 
//                 onClick = {this.props.checkSignIn}
//                 >Sign In
//                 </Button>
//               </Form.Group>
//             </Card.Body>
//         :
//         <Card.Body>
//             <RegisterBox
//             onNameChange = {this.props.onNameChange}
//             onEmailChange = {this.props.onEmailChange}
//             onPasswordChange = {this.props.onPasswordChange}/>
//              <Form.Group>
//               <Button 
//               variant = "secondary" 
//               onClick = {() => {this.props.onRouteChange('login')}}
//               >To Login
//               </Button>
//               <Button 
//               onClick = {this.props.onRegister}
//               variant = "secondary" 
//               >Register
//               </Button>
//              </Form.Group>
//             </Card.Body>
//         }
//         </Card>
//       )
//     }
//   }
    
  
// class SignInBox extends Component {
//     render () {
//         return (
//         <div >
//             <Form.Group className="mb-3">
//             <Form.Label>Username</Form.Label>
//             <Form.Control type="username" placeholder="Enter Username" 
//             onChange = {(event) => {this.props.onNameChange(event.target.value)}}/>
//             </Form.Group>
//             <Form.Group className="mb-3">
//             <Form.Label>Password</Form.Label>
//             <Form.Control type="password" placeholder="Enter Password"
//             onChange = {(event) => {this.props.onPasswordChange(event.target.value)}} />
//             </Form.Group>
//         </div>
//         )
//     }
// }
  
// class RegisterBox extends Component {
//     render () {
//       return (
//       <div >
//           <Form.Group className="mb-3">
//             <Form.Label>Username</Form.Label>
//             <Form.Control type="username" placeholder="Enter Username" 
//             onChange = {(event) => {this.props.onNameChange(event.target.value)}}/>
//           </Form.Group>
//           <Form.Group className="mb-3">
//             <Form.Label>Email</Form.Label>
//             <Form.Control type="email" placeholder="Enter Email"
//             onChange = {(event) => {this.props.onEmailChange(event.target.value)}} />
//           </Form.Group>
//           <Form.Group className="mb-3">
//             <Form.Label>Password</Form.Label>
//             <Form.Control type="password" placeholder="Enter Password"
//             onChange = {(event) => {this.props.onPasswordChange(event.target.value)}} />
//           </Form.Group>
//       </div>
//       )
//     }
//   }

class Authentication extends Component {
  render() {
    return (
      <>
      {this.props.state.route === 'login'
        ?
      <SignInBoxNew
        onNameChange = {this.props.onNameChange}
        onPasswordChange = {this.props.onPasswordChange}
        checkSignIn = {this.props.checkSignIn}
        onRouteChange = {this.props.onRouteChange}
        onGuestLogin = {this.props.onGuestLogin}
        state = {this.props.state}
      />
        :
      <RegisterBoxNew
        onNameChange = {this.props.onNameChange}
        onEmailChange = {this.props.onEmailChange}
        onPasswordChange = {this.props.onPasswordChange}
        onTermsChange = {this.props.onTermsChange}
        onAgeVerifiedChange = {this.props.onAgeVerifiedChange}
        agreedToTerms = {this.props.state.agreedToTerms}
        state = {this.props.state}
        onRegister = {this.props.onRegister}
        onRouteChange = {this.props.onRouteChange}
      />
     }
     </>
    )
  }
}

export default Authentication